import EStyleSheet from "react-native-extended-stylesheet";

export const styles = EStyleSheet.create({
  container: {
    textAlign: "center",
    backgroundColor: "$responsible_user_list_background",
    display: "flex-shrink",
    width: "50%",
  },
});
